import axios from "@/lib/request";

// 获取自定义产品订单列表
export const getCustomOrderList = (params) => {
  return axios.request({
    url: "/v1/admin/product/order/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取订单详情
export const getCustomOrderInfo = (params) => {
  return axios.request({
    url: "/v1/admin/product/order/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 重新出单
export const reIssueOrder = (data) => {
  return axios.request({
    url: "/v1/admin/product/order/issue",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 重新获取电子保单
export const reGetPolicy = (data) => {
  return axios.request({
    url: "/v1/admin/product/order/policy",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 手动回传保单信息
export const policyCallback = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/policy/callback",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};